<template>
  <main>
    <router-view :key="key" />
  </main>
</template>

<script>
export default {
  name: 'PublicLayoutMain',
  computed: {
    key () {
      return this.$route.path
    }
  }
}
</script>
